import de_DE from '../../date-picker/locale/de_DE'
export default de_DE



// WEBPACK FOOTER //
// ./components/calendar/locale/de_DE.js